export default "__VITE_ASSET__DdrfKOrc__"